// import {hots} from "../../data/mock.json"

export const hots = {
  computed: {
    hotCountries() {
      let arr = [];

      if (this.hot) {
        this.hot.forEach((el) => {
          el.sector.forEach((child) => {
            child.category = "sector";
          });

          el.specialism.forEach((child) => {
            child.category = "specialism";
          });
        });
        this.hot.forEach((el) => {
          arr.push({
            name: el.name,
            topics: el.sector.concat(el.specialism),
            tid: el.tid,
          });
        });

        arr.forEach((el2) => {
          el2.topics = this.getHots(el2.topics);
        });

        arr = arr.filter((el3) => el3.topics.length);
      }

      return arr;
    },
    hotTaxonomies() {
      let arr = [];
      if (this.sector) {
        this.sector.forEach((child) => {
          child.category = "sector";
        });
      }
      if (this.specialism) {
        this.specialism.forEach((child) => {
          child.category = "specialism";
        });
      }
      if (this.specialism && this.sector) {
        arr = this.specialism.concat(this.sector);
        arr = this.getHots(arr);
      }
      return arr;
    },
  },
  methods: {
    getHots(arr) {
      let newArr = [];
      arr.sort(function (a, b) {
        let one = a.count;
        let two = b.count;
        if (typeof a.count === "string") {
          one = parseFloat(one.split(",").join("."));
        }
        if (typeof b.count === "string") {
          two = parseFloat(two.split(",").join("."));
        }
        if (one > two) {
          return -1;
        }
        if (one < two) {
          return 1;
        }
        return 0;
      });
      newArr = arr.filter((el, index) => index < 3);
      newArr.forEach((el, index) => {
        if (index === 0) {
          el.width = 100;
        } else {
          let count = el.count;
          let first = newArr[0].count;
          if (typeof el.count === "string") {
            count = parseFloat(count.split(",").join("."));
          }
          if (typeof newArr[0].count === "string") {
            first = parseFloat(first.split(",").join("."));
          }
          el.width = (count * 100) / first;
        }
      });
      return newArr;
    },
  },
};
